import { render, staticRenderFns } from "./MzSearchBox.vue?vue&type=template&id=38431348"
import script from "./MzSearchBox.vue?vue&type=script&lang=js"
export * from "./MzSearchBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports